export const SERVER_URL = `${process.env.NODE_ENV === "development" ? "http://localhost:8191" : window.location.origin}`;

export const DEFAULT_SESSION_DURATION = 600; // minutes
export const MAX_SESSION_DURATION = 30 * (24 * 60); // days * (minutes in a day)

export const IPv4_IPv6_REGEX = /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;

export const ROLE_CATEGORIES = [
    {
        id: "primary",
        title: "Roles.Primary_Contact",
        quote: "Roles.Primary_Desc"
    },
    {
        id: "billing",
        title: "Roles.Billing_Contact",
        quote: "Roles.Billing_Desc"
    },
    {
        id: "decision",
        title: "Roles.Decision_Maker",
        quote: "Roles.Decision_Desc"
    },
    {
        id: "onboarding",
        title: "Roles.Onboarding_Contact",
        quote: "Roles.Onboarding_Desc"
    }
    // {
    //     id: "technical",
    //     title: "Technical Admin",
    //     quote: "I will manage all technical settings for this account, including domain and integration changes."
    // }
];

export const ACCESS_ROLE_PUBLIC = "public";
export const SDK_LICENSE_KEY = "sdk_licence";
export const ARRAY_ROLES_TO_FILTER_SSO = ["company_admin", "sdk_licence"];
export const ARRAY_ROLES_TO_FILTER = ["company_admin"];
